export default {
    async toBase64 (file){
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    },
    async sendPdfToAPI(self, pdfId= 0) {
        self.options.isUploading = true;
        let baseFile = self.uploadFile ? await this.toBase64(self.uploadFile) : "none";
        //hier noch den pfad für db angeben
        let uploadData = {
            file: baseFile,
            pdfName: self.fileName !== "" ? self.fileName : "none",
            brand: self.selectBrand !== "" ? self.selectBrand : "none",
            fileExtension: "",
            ...(pdfId !== 0 && { id: pdfId })
        }
        if(baseFile !== "none"){
            let fileExtension = self.uploadFile.name.split('.').pop().toLowerCase();
            if (fileExtension !== 'pdf' && fileExtension !== 'doc' && fileExtension !== 'docx' && fileExtension !== 'odt') {
                self.options.isUploading = false;
                self.options.showError = true;
                return;
            }
            uploadData.fileExtension = fileExtension;
            uploadData.dir = 'pdfs/' + uploadData.pdfName + '.' + uploadData.fileExtension
            uploadData.newDir = 'pdfs/'
        }
        self.doPost({data: uploadData}, pdfId === 0 ? 'uploadAllgemeinPdf' : 'updateAllgemeinPdf', function (res) {
            if (res.data.status === 'error') {
                self.help.log(self.$t(res.msg), false, true);
                self.fileName  = ""
                self.uploadFile = ""
                self.selectBrand = ""
            } else {
                //do stuff
                //self.getAllPdfsToTrip(self.refreshDialog);
                self.fileName  = ""
                self.uploadFile = ""
                self.selectBrand = ""
                self.options.isUploading = false;
                self.doPost({}, 'getAllgemeinPdf', function (res) {
                    if (res.data.status === 'error') {
                        self.help.log(self.$t(res.msg), false, true);
                    } else {
                        //console.log(self.pdfs);
                        self.fileName  = ""
                        self.uploadFile = ""
                        self.selectBrand = ""
                        self.pdfs = res.data.data;
                        self.getBrandName();
                    }
                });
            }
        });
    }
}